"use client";

import SectionTitle from "@/components/ui/SectionTitle";

import CaseStudy from "@/components/layout/CaseStudy";
import ClientStories from "@/components/layout/ClientStories";
import ResourcesPage from "@/components/layout/ResourcesPage";
import { FiShoppingBag } from "react-icons/fi";
import {
  MdOutlineAttachMoney,
  MdOutlineLaptop,
  MdOutlineLocalFlorist,
  MdOutlineShoppingCart,
  MdOutlineStore
} from "react-icons/md";


import ToolsStack from "@/components/section-infographic/DesignAndDevelopmentAsAService/ToolsStack";
import IndustryHero from "@/components/SectionHero/IndustryHero";
import CTABanner from "@/components/organisms/CTABanner";
import FAQ from "@/components/ui/FAQ";
import IndustriesComplianceSection from "@/components/ui/IndustriesComplianceSection";
import CardSection from "@/components/ui/IndustriesMutiPurposeZigZagSection";
import IndustriesNewMegaCarSection from "@/components/ui/IndustriesNewMegaCarSection";
import IndustriesTable from "@/components/ui/IndustriesTable";
import NewMegaCardSection from "@/components/ui/NewMegaCarSection";
import PrimaryPromotionBanner from "@/components/ui/PrimaryPromotionBanner";
import SkewSatusCardsSection from "@/components/ui/SkewSatusCardsSection";
import SkewCardsSection from "@/components/organisms/pages-sections/IndustriesSkewCardsSection";



export default function UiUxDesignPage() {




  const faqData = [
    {
      question: "What e-commerce development services does Make My Brand provide?",
      answer:
        "We offer end-to-end e-commerce website development services, including Shopify, Magento, WooCommerce, custom website design, and mobile-friendly platforms.",
    },
    {
      question: "Can you help optimize my online store’s user experience?",
      answer:
        "Yes. Our e-commerce UX/UI design services focus on conversion-focused product pages, checkout optimization, and personalized shopping experiences to boost sales.",
    },
    {
      question: "How do you support e-commerce growth and digital marketing?",
      answer:
        "We provide multi-channel marketing, e-commerce sales funnel optimization, customer retention strategies, and data-driven growth models tailored for e-commerce brands.",
    },
    {
      question: "Can Make My Brand integrate automation and analytics into my store?",
      answer:
        "Yes. We implement marketing automation, abandoned cart flows, AI-powered product recommendations, analytics dashboards, and e-commerce CRM automation integration for smarter operations.",
    },
    {
      question: "How do I get started with Make My Brand for my e-commerce store?",
      answer:
        "Book a free consultation or request a proposal, and our team will analyze your store, identify growth opportunities, and create a tailored strategy using our e-commerce BDLC framework.",
    },
  ];





  return (
    <main className="overflow-hidden">


      <IndustryHero svgPath="/HeroSectionImg/Ecommerce-HeroImage.svg" />


      <PrimaryPromotionBanner
        title="Lead the Market with a High-Performing E-Commerce Experience"
        description="We design e-commerce growth systems that build loyal customers, measurable impact, and long-term market leadership."
        buttonLabel="Get Your Custom Proposal Today"
        
        buttonLink="/contact-us"
      />


      <SkewSatusCardsSection
        sectionTitle="E-Commerce Needs MMB BDLC?"
        sectionDescription={[
          "E-commerce is about creating experiences that convert visitors into loyal customers. Brand perception directly influences conversions and market leadership. ",
          "At Make My Brand, our 360-degree Brand Development Life Cycle (BDLC) provides exactly that. We combine data-driven insights, user-centered design, and automation to help e-commerce brands: "
        ]}
        backgroundClass="white"
        sectionSubtitle="Why"

        cards={[
          { description: 'Build intuitive, mobile-first e-commerce design stores that make browsing, shopping, and checkout effortless.' },
          { description: 'Connect CRMs, payment gateways, and logistics systems for smooth operations.' },
          { description: 'Implement AI-driven personalization, automated workflows, and targeted campaigns.' },
          { description: 'Establish a strong brand presence, optimize performance, and measure impact at every stage.' },
        ]}
      />



      <section className=" py-12 lg:py-16 xl:py-20 2xl:py-24 relative overflow-hidden xl:section-bg-white-soft">
        <div className="custom-container mx-auto px-4 md:px-8 mb-16">
          <SectionTitle
            title="Key Challenges We Solve"
            description="E-commerce brands face hurdles that can limit growth, impact customer trust, and reduce operational efficiency. We tackle these challenges head-on, blending design, development, and data-driven strategies to create scalable, high-performing digital commerce platforms. "
            align="center"
          />

        </div>
        <NewMegaCardSection
          leftImage="/section-background-images/ecommerce-key-challenges.png" // Replace with your actual image path
          imageAlt="Team collaboration"
          cards={[
            {
              title: "Fragmented Customer Journeys",
              description:
                "Disjointed navigation, slow load times, and inconsistent experiences across devices lead to lost sales and lower retention.",
            },
            {
              title: "Technical Complexity & Integrations",
              description:
                "Managing multiple systems such as CRMs, ERP, inventory, logistics, and payment gateways can be overwhelming.",
            },
            {
              title: "Conversion & Checkout Friction",
              description:
                "Complicated checkout processes, limited payment options, or poor product catalog UX design increase cart abandonment.",
            },
            {
              title: "Brand Consistency & Visual Identity",
              description:
                "Inconsistent design, messaging, or product presentation erodes credibility and trust, reducing customer engagement and repeat purchases.",
            },
            {
              title: "Performance & Scalability Challenges",
              description:
                "Many e-commerce platforms lack data-driven testing, analytics dashboards, or CRO strategies, preventing brands from maximizing revenue and ROI.",
            },
            {
              title: "Data, Security & Compliance Risks",
              description:
                "Payment security, PCI-DSS standards, GDPR compliance, and safe customer data management are critical yet often overlooked, risking trust and legal complications.",
            },
            {
              title: "Market Differentiation & Growth Optimization",
              description:
                "In saturated markets, standing out requires more than products—it demands a cohesive brand identity, visual system, and storytelling that builds trust and loyalty.",
            },
            {
              title: "Scalable Growth",
              description:
                "Expanding product lines, channels, or markets without proper architecture and performance monitoring can slow growth and create operational inefficiencies.",
            },
          ]}



        />
      </section>

      <CardSection
        sectionTitle="Our Approach"
        sectionDescription="At Make My Brand, we engineer e-commerce ecosystems designed for growth, performance, and customer delight."
        cards={[
          {
            number: "01",
            title: "Discover",
            description:
              "Deep dive into your vision, learner needs, and market landscape to identify growth opportunities.",
          },
          {
            number: "02",
            title: "Design",
            description:
              "Create learner-centric interfaces, intuitive platforms, and engaging content that enhance learning experiences.",
          },
          {
            number: "03",
            title: "Analyze",
            description:
              "Track learner progress, engagement metrics, and ROI through real-time dashboards and insights.",
          },
          {
            number: "04",
            title: "Strategize",
            description:
              "Build a clear roadmap for brand positioning, digital presence, and scalable Ed-Tech business models.",
          },
          {
            number: "05",
            title: "Implement",
            description:
              "Integrate LMS, CRM, assessment tools, and automation systems for seamless delivery and engagement.",
          },
          {
            number: "06",
            title: "Scale",
            description:
              "Expand to new courses, markets, and geographies with consistent branding and optimized digital ecosystems.",
          },
        ]}

      />

      <div className="relative bg-gray-100/50 overflow-hidden">
        <IndustriesNewMegaCarSection
          sectionTitle={{
            title: "Our E-Commerce Expertise",

            align: "left"
          }}

          cards={[
            {
              title: "Custom E-Commerce Development",
              description: "",
            },
            {
              title: "UX/UI Design & Optimization",
              description: "",
            },
            {
              title: "Multi-Vendor & Headless Commerce Solutions",
              description: "",
            },
            {
              title: "Payment Gateway & Platform Integration",
              description: "",
            },
            {
              title: "E-Commerce SEO Services & Content Marketing",
              description: "",
            },
            {
              title: "Marketing Automation & Personalization",
              description: "",
            },
            {
              title: "Paid & Performance Marketing",
              description: "",
            },
            {
              title: "Analytics & Conversion Optimization",
              description: "",
            },
          ]}


        />
      </div>

      <section className="py-12 lg:py-16 xl:py-20 2xl:py-24">
        <SkewCardsSection
          heading="Our expertise spans the entire e-commerce ecosystem, including"
          cards={[
            {
              icon: <MdOutlineShoppingCart />,
              title: "Direct-to-Consumer (DTC) Brands ",
            },
            {
              icon: <MdOutlineStore />,
              title: "Marketplaces & Multi-Vendor Platforms",
            },
            {
              icon: <FiShoppingBag />,
              title: "Fashion, Lifestyle & FMCG Retailers",
            },
            {
              icon: <MdOutlineLaptop />,
              title: "Electronics & Tech E-Commerce",
            },
            {
              icon: <MdOutlineAttachMoney />,
              title: "Subscription & Service-Based E-Commerce",
            },
            {
              icon: <MdOutlineLocalFlorist />,
              title: "Niche & Emerging Online Brands",
            },
          ]}
        />
      </section>

      <CaseStudy />




      <ToolsStack
        title="Our Tech Stack & Tools"
        description="Our stack consolidates best-in-class tools to ensure every content initiative is data-driven, conversion-focused, and generated for long-term impact."
        categories={[
          {
            title: "Collaboration & Project Management",
            items: ["Slack", "Zoom", "Teams", "Notion", "Google Drive", "Figma"],
          },
          {
            title: "Analytics & Reporting",
            items: ["GA4", "Looker Studio", "Google Search Console", "Ahrefs", "Screaming Frog", "SEMrush", "Surfer"],
          },

          {
            title: "Automation & Growth Tools",
            items: ["Klaviyo", "HubSpot", "Make.com", "AI-powered personalization engines", "Zapier"],
          },
          {
            title: "Payment & Platform Integrations",
            items: ["Secure payment gateways", "ERP", "and CRM systems", "API integrations"],
          },
          {
            title: "Design & Development",
            items: ["Figma", "Adobe XD", "Illustrator", "Photoshop", "Webflow", "Shopify", "Magento", "React.js", "WooCommerce", "TailwindCSS", "InVision", "Marvel", "Framer"],
          },
        ]}
        withBackground={true}
        special5={true}
      />


      <IndustriesTable
        title="Impact Metrics (results)"
        rows={[
          {
            label: "Total Impressions",
            value: "9.18 million+",
          },
          {
            label: "Total Clicks",
            value: "42,322",
          },
          {
            label: "Average CTR",
            value: "0.46%",
          },
          {
            label: "Device Share",
            value: "Mobile > Tablet > Desktop",
          },
          {
            label: "Top Countries",
            value: "India, USA, Vietnam, Philippines",
          },
        ]}
      />

      <IndustriesComplianceSection
        sectionTitle={{
          title: "Compliance & Data Security Assurance",
          description: [
            "We understand that trust is the cornerstone of every successful e-commerce business. That's why we prioritize data security and regulatory compliance in every solution we deliver."
          ],
        }}
        rightColumnItems={[
          {
            heading: "PCI DSS Compliance",
            text: "Secure payment processing and cardholder data protection.",
          },
          {
            heading: "SSL/TLS Encryption",
            text: "Encrypted data transfer for safe browsing and transactions.",
          },
          {
            heading: "Regular Security Audits",
            text: "Ongoing vulnerability checks and proactive risk management.",
          },
          {
            heading: "User Consent Management",
            text: "Transparent privacy policies and cookie consent.",
          },
          {
            heading: "GDPR & CCPA Adherence",
            text: "Safeguarding customer privacy and data rights.",
          },
          {
            heading: "Two-Factor Authentication",
            text: "Extra layer of security for admin access.",
          },
          {
            heading: "Global Regulatory Compliance",
            text: "Aligning regional and international e-commerce regulations.",
          },
        ]}
      />




      <ClientStories />

      <CTABanner
        title="Maximize Growth with Expert E-Commerce Solutions."
        buttonText="Talk to Our Experts"
        // buttonOnClick={handleCTAButtonClick}
        bgColor="#313866"
        textColor="#fff"
        buttonVariant="primary"
      />


      <FAQ
        faqData={faqData}
        title="Frequently Asked Questions"
      />

      <ResourcesPage />
    </main>
  );
}


